import { createAction } from '@reduxjs/toolkit'

import type { SharedData } from './shared-state'

// Every slice reacts to this one action. Domain changes are NOT shared actions: a command dispatches each slice's own
// actions inside one `commit`, which makes the group all-or-nothing. Payloads are fully built (ids, timestamps) before
// dispatch so reducers stay pure.

/** Replaces all shared data with a newer copy from storage. Never causes a write. */
export const sharedHydrated = createAction<{ data: SharedData; revision: number }>('shared/hydrated')
